export default class LazyLoad {

    /*
    options:
     */

    /*
    events :
        lazy-loaded
     */

    constructor(options) {
        if (options === undefined) {
            options = {};
        }
        this.options = {}
        window.addEventListener('load', (e) => {
            this.init();
        });
    }

    init() {
        const images = document.querySelectorAll('[data-src]');
        const config = {
            rootMargin: '0px 0px 50px 0px',
            threshold: 0
        };

        let observer = new IntersectionObserver((entries, self) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.preloadImage(entry.target);
                    self.unobserve(entry.target);
                }
            });
        }, config);

        images.forEach(image => {
            observer.observe(image);
        });

        let loadElements = document.querySelectorAll('[data-load]');
        loadElements.forEach((v) => {
            v.setAttribute('src', v.dataset["load"]);
        });
    }

    preloadImage(img) {
        const src = img.getAttribute('data-src');
        if (!src) {
            return;
        }
        window.dispatchEvent(new CustomEvent('lazy-loaded', {
            detail: {
                target: img,
            }
        }))
        img.src = src;
    }
}
